//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';

export class TeacherSummaryDisplayItem extends ItemBase {
    TeacherID: string | null = null;
    StudentIDs: string[] = [];
    FamilyIDs: string[] = [];
    Teacher: TeacherNameDisplayItem | null = null;

    constructor(initializer?: Partial<TeacherSummaryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherSummaryDisplayItem";
}
